import { useCallback } from 'react';
import { useAppSelector } from 'store/hooks';
import { Tier } from 'features/premium/entities';
import { selectUserTier } from 'features/premium/selectors/tier';
import { useMainStackNavigation } from 'utils/types/navigationV6';
const useNavigateAfterIssueStep = () => {
    const navigation = useMainStackNavigation();
    const tier = useAppSelector(selectUserTier);
    const onPressDelete = useCallback(() => {
        if (tier === Tier.free) {
            navigation.navigateDeprecated('DeleteBenefits');
        }
        else {
            navigation.navigateDeprecated('DeleteSupport');
        }
    }, [tier]);
    return onPressDelete;
};
export default useNavigateAfterIssueStep;
